
import Vue from 'vue'
import {Component, Watch} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import DocumentForm from '@/components/forms/DocumentForm.vue'
import VueScrollTo from 'vue-scrollto'

const prospectModule = namespace('prospect')
const documentModule = namespace('document')

@Component({
  components: {
    BaseCardContainer,
    DocumentForm
  }
})
export default class ProspectDocumentUpdate extends Vue {
  @documentModule.Getter('documentGetter') document: any
  @prospectModule.Getter('prospectGetter') prospect: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @documentModule.Action('getDocumentByIdAction') getDocumentById: any
  @documentModule.Action('updateDocumentAction') updateDocument: any

  @Watch('$route.params.documentId', {immediate: true, deep: false})
  onUrlChange(newVal: any) {
    this.getDocumentById(newVal)
  }

  mounted() {
    this.getDocumentById(this.$route.params.documentId)
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  onSubmit(data: any) {
    this.updateDocument({
      id: this.$route.params.documentId,
      formParams: data
    }).then(async (data: any) => {
      await this.getProspectById(this.$route.params.id)
      this.$router.push({name: 'prospectDocument', params: {id: this.$route.params.id}})
    })
  }

  onCancel() {
    this.$router.push({name: 'prospectDocument', params: {id: this.$route.params.id}})
  }
}
